export const selectTemplateName = ({fabricTemplate}) => fabricTemplate.templateName;
